"use client";
import Layout6 from "./ContactLayouts/Layout6";
import Layout7 from "./ContactLayouts/Layout7";


interface Button {
  id: string;
  text: string;
  type: string;
}

interface Address {
  id: number;
  text?: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  Phone?: string; 
  email?: string;
}

interface SocialLink {
  id: number;
  text: string;
  social: 'INSTAGRAM' | 'FACEBOOK' | 'TWITTER' | 'LINKEDIN' | 'YOUTUBE' | 'PINTEREST' | 'DISCORD' | 'WEBSITE' | string;
  url: string;
  newTab: boolean;
}

interface LinkItem {
  id: number;
  text: string;
  url: string;
  dropdownLinks?: DropdownLink[];
  newTab?: boolean;
}

interface DropdownLink {
  data:{
    label: string;
    url: string;
  }
}

interface ContactProps {
  id: number;
  title: string;
  description: string | null;
  isLive: boolean;
  useH1Tag: boolean;
  mapUrl?: string;
  layout: string;
  button: Button[];
  link: LinkItem[];
  socialLinks: SocialLink[];
  addresses: Address[];
}


export default function ContactForm({ data }: { data: ContactProps }) {

  return (
    <>
      {
        data.layout == "SPLIT_FORM_MAP" ? <Layout7 data={data} /> :
          <Layout6 data={data} />
      }
    </>
  );
}
